


































































































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import { ShouninNode, ShouninStep } from '@/tcw/domain/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import { InvalidFields } from '@/components/common/form/types'

@Component
export default class ShouninRouteStep extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      return {}
    }
  })
  private shouninStep!: ShouninStep
  @Prop({ default: 0 })
  private stepIdx!: number
  @Prop({ type: Boolean, default: false })
  private editable!: boolean
  @Prop({
    default: () => {
      /** */
    }
  })
  private serverCheckInfo!: InvalidFields

  @Emit()
  private add(_step: number): void {
    //
  }

  @Emit()
  private remove(_step: number, _nodeId: number): void {
    //
  }

  @Emit()
  private edit(_step: number, _nodeId: number): void {
    //
  }

  get nodeList(): ShouninNode[] {
    return this.shouninStep.nodeList
  }
}
